import script from "./ContentPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentPage.vue?vue&type=script&lang=ts&setup=true"

import "./ContentPage.vue?vue&type=style&index=0&id=5b4760c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4760c2"]])

export default __exports__